import { render, staticRenderFns } from "./OnlyHtml.vue?vue&type=template&id=4987ab9c&"
import script from "./OnlyHtml.vue?vue&type=script&lang=js&"
export * from "./OnlyHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports